import React, { useState } from "react";
import StandardButton from "../Buttons/StandardButton";
import DropDownMenu from "./DropDownMenu";

const HeaderBar = (props) => {
  const [buttonLoadingMap, setButtonLoadingMap] = useState({});

  let overflowOptions = [];
  if (props.buttons && props.buttons.length > 1) {
    overflowOptions = props.buttons.map((b) => ({
      label: b.label,
      operation: b.onClick,
      color: b.color || "blue",
      disabled: b.disabled || false,
      disabledClick: b.disabledClick,
    }));
    overflowOptions.pop();
  }

  const pxPadding = props.titleLink ? "px-2 md:px-4" : "px-2 md:px-10";

  return (
    <div
      className={`flex flex-row place-items-center justify-between w-full h-20 border-b-2 border-snow-primary ${pxPadding}`}
    >
      <div className="text-xl lg:text-3xl font-medium text-snow-primary">
        {props.titleLink ? props.titleLink : props.title}
      </div>
      <div className="flex justify-end">
        {props.buttonSection ? props.buttonSection : null}
        {props.button?.enabled ? (
          <StandardButton
            as={props.button.as}
            color={props.button.color || "blue"}
            disabled={props.button.disabled || false}
            label={props.button.label}
            onClick={props.button.onClick}
            testId={props.button.testId}
            title={props.button.title}
          />
        ) : null}
        {props.buttons?.map((item, key) => (
          <div
            className={`ml-4 ${key === props.buttons.length - 1 ? "" : "hidden"} lg:block print:hidden`}
            key={key}
          >
            <StandardButton
              as={item.as}
              className={item.className}
              color={item.color || "blue"}
              disabled={item.disabled || false}
              disabledClick={item.disabledClick ?? undefined}
              label={item.label}
              loading={item.loading || buttonLoadingMap[key]}
              testId={
                item.testId ??
                (typeof item.label === "string"
                  ? `header-button-${item.label}`
                  : undefined)
              }
              title={item.title}
              onClick={async () => {
                setButtonLoadingMap((current) => ({
                  ...current,
                  [key]: true,
                }));
                await item.onClick?.();
                setButtonLoadingMap((current) => ({
                  ...current,
                  [key]: false,
                }));
              }}
            />
          </div>
        ))}
        {props.buttons && props.buttons.length > 1 ? (
          <DropDownMenu className="lg:hidden mx-4" options={overflowOptions} />
        ) : null}
        {props.children ? props.children : null}
      </div>

      {props.dropdown?.enabled ? (
        <DropDownMenu options={props.dropdown.options} />
      ) : null}
    </div>
  );
};

export default HeaderBar;
